import styled from '@emotion/styled'
import {theme} from '../Dashboard/theme'
import {PTBgPattern} from '../../../../assets'

const NAVY_DARK = '#131836'
const ORANGE = '#FF5000'

const BG_PATTERN_URL = `url(${PTBgPattern})`

export const PageWrap = styled.div`
  // background-color: #5c6c9e;
  // background-image: ${BG_PATTERN_URL},
  //   linear-gradient(0deg, rgba(92, 108, 158, 1) 0%, rgba(22, 28, 54, 1) 100%);
  background: linear-gradient(179.57deg, #171d37 0.38%, #6474a9 108.67%);
  background-size: 18%, 100%;
  // background-attachment: fixed, scroll;
  // background-repeat: repeat, no-repeat;
  // background-position: top left, center center;
  // background-origin: border-box, border-box;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: ${theme.font.family};
`
export const Container = styled.div`
  margin: 0 auto;
  max-width: 1400px;
  width: 100%;
`
export const NavBar = styled.header`
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  top: 0;
  z-index: 100;

  @media (max-width: 600px) {
    padding: 12px 16px;
  }
`

export const NavLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  span {
    width: 1px;
    height: 36px;
    background: #ffffff42;
  }

  img {
    @media (max-width: 480px) {
      height: 22px !important;
    }
  }

  @media (max-width: 480px) {
    gap: 10px;
  }
`

export const NavRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
`

export const NavForLabel = styled.span`
  font-size: 11px;
  font-weight: 400;
  color: #ffffff;
  letter-spacing: 0.3px;
  font-family: ${theme.font.family};
`

export const NavBusinessName = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.1px;
  font-family: ${theme.font.family};
`

export const GradientSection = styled.section`
  // background-image: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, #465a9d76 100%);
  border-radius: 25px 25px 0 0;
`

export const HeroSection = styled.section`
  padding: 40px 40px 0;

  @media (max-width: 900px) {
    padding: 28px 20px 0;
  }

  @media (max-width: 600px) {
    padding: 20px 16px 0;
  }
`

export const HeroTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;
  position: relative;

  @media (max-width: 700px) {
    flex-direction: column;
    gap: 16px;
  }
`

export const HeroContent = styled.div`
  flex: 1;
  min-width: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 5px;
`

export const HeroMeta = styled.p`
  margin: 0 0 10px;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
  font-family: ${theme.font.family};
`

export const HeroTitle = styled.h1`
  margin: 0 auto 10px;
  font-size: 26px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.2;
  letter-spacing: -0.3px;
  font-family: ${theme.font.family};

  @media (max-width: 900px) {
    font-size: 22px;
  }

  @media (max-width: 600px) {
    font-size: 18px;
  }
`

export const HeroActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 6px;
  flex-shrink: 0;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;

  @media (max-width: 700px) {
    position: static;
    align-items: flex-start;
    width: 100%;
  }
`

export const NotQuiteRight = styled.span`
  font-size: 12px;
  color: #fff;
  font-family: ${theme.font.family};
`

export const RequestChangesBtn = styled.button`
  background: #d6def0;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border-radius: ${theme.radius.full};
  border: 1.5px solid rgba(255, 255, 255, 0.25);
  color: ${theme.colors.primary};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.2px;
  font-family: ${theme.font.family};
  transition: background ${theme.transition.fast},
    transform ${theme.transition.fast}, border-color ${theme.transition.fast};

  &:hover {
    transform: scale(1.01);
  }

  &:active {
    transform: scale(0.99);
  }

  &:focus {
    outline: none;
  }
`

export const ValidityBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 5px 10px;
  border-radius: 24px;
  background: rgba(254, 243, 199, 0.1);
  border: 1px solid rgba(249, 176, 51, 0.4);
  box-shadow: 0 0 2px 1px rgba(249, 176, 51, 0.4) inset;
  margin-bottom: 12px;

  img {
    flex-shrink: 0;
    margin-top: 2px;
  }
`

export const ValidityText = styled.p`
  margin: 0;
  font-size: 13px;
  color: rgba(255, 244, 210, 0.9);
  font-family: ${theme.font.family};
  line-height: 1.4;
`

export const PricingDisclaimer = styled.p`
  margin: 0;
  font-size: 12px;
  font-style: italic;
  color: rgba(255, 255, 255, 0.5);
  font-family: ${theme.font.family};
`

/* Optional note the sales rep attached when sending the proposal. */
export const RepNotePanel = styled.section`
  margin: 0 0 20px;
  padding: 14px 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);

  @media (max-width: 600px) {
    padding: 12px 14px;
  }
`

export const RepNoteTitle = styled.h2`
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: rgba(255, 255, 255, 0.7);
  font-family: ${theme.font.family};
`

export const RepNoteText = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.92);
  font-family: ${theme.font.family};
  /* Keep the line breaks the rep typed. */
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

export const CardsSection = styled.div`
  // background-image: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, #465a9d76 100%);
  flex: 1;
  padding: 0 32px 40px;
  border-radius: 25px 25px 0 0;

  @media (max-width: 900px) {
    padding: 0 20px 28px;
  }

  @media (max-width: 600px) {
    padding: 0 16px 20px;
  }
`

export const CardsInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`

export const PageFooter = styled.footer`
  padding: 10px 40px;
  text-align: center;
`

export const FooterText = styled.p`
  margin: 0;
  font-size: 12px;
  color: #ffffff;
  font-family: ${theme.font.family};
`

/* ───────── Request Changes Modal ───────── */

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`

export const ModalCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 800px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;

  @media (max-width: 600px) {
    border-radius: 12px;
  }
`

export const ModalHeader = styled.div`
  padding: 28px 40px 20px;
  text-align: center;

  @media (max-width: 600px) {
    padding: 24px 20px 16px;
  }
`

export const ModalTitle = styled.h2`
  margin: 0 0 10px;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  font-family: ${theme.font.family};
`

export const ModalSubtitle = styled.p`
  margin: 0;
  font-size: 13px;
  font-family: ${theme.font.family};
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 8px;
`

export const ModalDivider = styled.hr`
  margin: 0;
`

export const ModalBody = styled.div`
  padding: 0 40px 30px;

  @media (max-width: 600px) {
    padding: 0 20px 24px;
  }
`

export const ModalLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 10px;
  font-family: ${theme.font.family};
`

export const ModalTextarea = styled.textarea`
  width: 100%;
  min-height: 140px;
  padding: 12px 14px;
  border: 1px solid #c1c3c5;
  border-radius: 8px;
  font-size: 13px;
  color: #374151;
  font-family: ${theme.font.family};
  resize: vertical;
  box-sizing: border-box;
  line-height: 1.5;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #181e38;
  }
`

export const ModalFooter = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
`

export const ModalCloseBtn = styled.button`
  position: absolute;
  top: 14px;
  right: 18px;
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  font-size: 22px;
  line-height: 1;
  padding: 4px 6px;
  font-family: sans-serif;
  transition: color ${theme.transition.fast};

  &:hover {
    color: #374151;
  }

  &:focus {
    outline: none;
  }
`

export const StickyBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${NAVY_DARK};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 14px 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  z-index: 99;

  @media (max-width: 600px) {
    padding: 12px 16px;
    flex-direction: column;
    gap: 8px;
  }
`

export const StickyLabel = styled.span`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  font-family: ${theme.font.family};
`

export const ProceedBtn = styled.button`
  padding: 11px 32px;
  border-radius: ${theme.radius.full};
  border: none;
  background: ${ORANGE};
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.4px;
  cursor: pointer;
  font-family: ${theme.font.family};
  transition: background ${theme.transition.fast};

  &:hover {
    background: #e04500;
  }

  &:focus {
    outline: none;
  }
`
